import React from "react"
import { Link } from "react-router-dom"
import IF from "../components/IF"
import { path } from "../core/utils"

const renderSituacao = status => {
    switch (status) {
        case "Ativo":
            return <span className="has-text-success">{status}</span>
        case "Inativo":
            return <span className="has-text-danger">{status}</span>
        default:
            return <span className="has-text-grey">{status}</span>
    }
}

const renderTdBoletoOrRepasse = item => {
    if (item.participacao === "Locatario") {
        return (
            <>
                <td>Locatário</td>
                <td>
                    <Link to={`${path}/contratos/${item.id}`} className="button is-link is-small">
                        Ver Boletos
                    </Link>
                </td>
            </>
        )
    } else {
        return (
            <>
                <td>Proprierário</td>
                <td>
                    <IF test={item.situacao === "Ativo" && item.vigente !== ""}>
                        <a
                            rel="noopener noreferrer"
                            href={item.vigente.link}
                            target="_blank"
                            className="button is-primary is-small"
                        >
                            Ver Extrato
                        </a>
                    </IF>
                </td>
            </>
        )
    }
}

export default props => {
    let item = props.contrato
    return (
        <tr>
            <td>
                <Link to={`${path}/contratos/${item.id}`} className="button is-info is-small">
                    {item.codigo}
                </Link>
            </td>
            <td>
                ({item.imovel.codigo}) {item.imovel.endereco}
            </td>
            <td>{item.vigencia}</td>
            <td>{renderSituacao(item.situacao)}</td>
            {renderTdBoletoOrRepasse(item)}
        </tr>
    )
}
